import { Component, ComponentProps } from "solid-js";

import { Icon as Icon_ } from "@/iro/objects/Icon";
import icons from "#/icons.svg";
import symbols from "#/symbols.svg";

export const Icon: Component<ComponentProps<typeof Icon_>> = (props) => {
    return <Icon_ source={props.id === "loading" ? symbols : icons} {...props} />;
};
